export default "__VITE_ASSET__8WELNO$B__"